import { Observable } from "rxjs";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { Injectable } from "@angular/core";
import { AuthContractsComponent } from "./auth-contracts.component";
import { HttpClient } from "@angular/common/http";
import { routes } from "environments/environment";
import { AppLoaderService } from "../app-loader/app-loader.service";
import { map } from "rxjs/operators";

@Injectable()
export class AuthContractsService {
  private dialogRef: MatDialogRef<AuthContractsComponent>;
  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private loader: AppLoaderService
  ) {}

  public open(data): Observable<boolean> {
    this.dialogRef = this.dialog.open(AuthContractsComponent, {
      maxHeight: "50em",
      minHeight: "10em",
      width: "40em",
      disableClose: true,
      data: data,
    });

    // this.dialogRef.afterClosed().subscribe(dataClosed => {
    //   console.log(dataClosed);
    // })

    return this.dialogRef.afterClosed();
  }

  public close() {
    this.dialogRef.close();
  }

  public contracts(cpfCnpj, currCodeCobra?) {
    this.loader.open("Aguarde, carregando contratos...");

    this.http
      .get(
        `${routes.auth_searches_contracts}?cpfcnpj=${cpfCnpj}&statuscontract=abletoshowonatende`
      )
      .pipe(map((res: any) => {
        let response = res.data.contracts;

        // Remove contrato selecionado da lista
        response = response.filter(function(value, index, arr) {
          return typeof currCodeCobra != "undefined" && value.codeCobra != currCodeCobra
        });

        return response;
      }))
      .subscribe((res) => {
        this.loader.close();
        this.open(res);
      });
  }
}
